/** @jsxImportSource @emotion/react */
import OverlayTrigger, { OverlayTriggerProps } from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

export const TooltipWrapper = ({
  text,
  children,
  show,
  maxWidth,
  placement = 'bottom',
  visible,
}: {
  text: string | (() => JSX.Element)
  children: JSX.Element
  show?: boolean
  maxWidth?: number
  placement?: OverlayTriggerProps['placement']
  // Shown only while true, ignoring hover and focus; the trigger stays mounted either way.
  visible?: boolean
}): JSX.Element => {
  const renderTooltip = (props: any) => (
    <Tooltip
      id="button-tooltip"
      css={maxWidth ? { '& .tooltip-inner': { maxWidth } } : undefined}
      {...props}>
      {typeof text === 'string' ? text : typeof text === 'function' ? text() : null}
    </Tooltip>
  )

  if (!text || !show) return children

  return (
    <OverlayTrigger
      placement={placement}
      overlay={renderTooltip}
      {...(visible === undefined ? {} : { trigger: [], show: visible })}>
      {children}
    </OverlayTrigger>
  )
}
